<template>
  <div class="dropdown notification-dropdown unread-notification-bell">
    <button id="notificationDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="d-flex">
      <span class="icon-and-count">
        <span class="icon" :class="[notifications.length > 0 ? 'notification-on' : 'notification-off']"></span>
        <span v-if="!hasNoNotifications" class="notification-count">{{ unreadCount }}</span>
        <span class="sr-only">Notification Bell Button</span>
      </span>
    </button>
    <div class="dropdown-menu dropdown-menu-right pb-0" aria-labelledby="notificationDropdown" style="left: auto;">
      <a
        v-for="notification in firstTenNotifications"
        :key="notification.id"
        class="dropdown-item py-3 px-4"
        @click="markNotificationAsRead(notification)"
        :href="notificationLink(notification)">
        <div class="row">
          <icon :glyph="glyphFor(notification)" class="col-2 pr-0"></icon>
          <h2 class="col-10 pl-0 label-sm">{{notification.title}}</h2>
        </div>
        <div class="date row justify-content-end">
          <div class="col-10 pl-0">
            <span v-if="shouldShowAuthor">
              {{formattedAuthor(notification)}}
            </span>
            <relative-date-time :timezone="timezone" :created_at="notification.c_at"></relative-date-time>
          </div>
        </div>

        <div class="row justify-content-end">
          <p v-html="formattedMessage(notification.message)" class="notification-message col-10 pl-0"></p>
        </div>
      </a>
      <p v-if="hasNoNotifications" class="dropdown-item py-3">You have no new notifications</p>
      <a v-if="hasOverTenNotifications" class="dropdown-item py-3" href="/notifications">
        View all {{ unreadCount }} unread notifications in feed
      </a>
      <div class="cta">
        <a class="btn xs blue outline" href="/notifications">Go to my feed</a>
        <button type="button" class="btn-link blue" @click="fetchNotifications">Refresh</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ToLocalDateTime from "../toLocalDateTime.vue";
import RelativeDateTime from "~/components/relativeDateTime.vue";
import {RouteHelper} from "~/helpers/routeHelper";
import {Route} from "~/enums/route";
import {AppNotificationType} from "../../../formability/notifications/enums/appNotificationType";
export default Vue.extend({
  components: {
    RelativeDateTime,
    ToLocalDateTime
  },
  mixins: [],
  data: function() {
    return {
    };
  },
  computed: {
    unreadCount() {
      return this.$store.state.appNotificationStore.unreadCount;
    },
    notifications() {
      return this.$store.state.appNotificationStore.unreadNotifications.filter(notification => {
        return !notification.is_hidden;
      });
    },
    firstTenNotifications() {
      return this.notifications.slice(0, 10);
    },
    timezone() {
      return this.$store.state.selected.organization.time_zone
    },
    hasNoNotifications(): boolean {
      return this.notifications.length === 0;
    },
    hasOverTenNotifications(): boolean {
      return this.unreadCount > 10;
    },
    notificationCount(): string {
      return this.notifications.length > 99
        ? '99+'
        : `${this.notifications.length}`;
    },
  },
  created () {
    this.fetchNotifications();
  },
  methods: {
    fetchNotifications() {
      this.$store.dispatch('appNotificationStore/checkForUnreadNotifications');
    },
    clearNotifications() {
      this.$store.dispatch('appNotificationStore/clearNotifications');
    },
    async markNotificationAsRead(notification) {
      await this.$store.commit('appNotificationStore/updateUnreadNotifications', {notifications: this.notifications.filter((element) => {return element.is_read === false}), unread_count: this.unreadCount - 1})
      await this.$store.dispatch('appNotificationStore/updateNotification', notification)
      this.notifications.is_read = !this.notifications.is_read
    },
    formattedMessage(message): string { if (message?.length > 100) { return message.slice(0, 100) + '...' } else { return message } },
    navigateToMention(notification) {
      if(notification.document_type === "Form Submission"){
        return RouteHelper.path({route: Route.formSubmission, modelOrId: notification.document_id, query: {note: notification.note_id}})
      }else if(notification.document_type === "Detail View"){
        if(notification.linked_detail_view_id) {
          return RouteHelper.path({
            route: Route.detailView,
            query: {note: notification.note_id},
            namedWildcardOptions: [
              {wildcard: ":id", modelOrId: notification.linked_detail_view_id},
              {wildcard: ":entry_id", modelOrId: notification.document_id}
            ],
          })
        }
      }
    },
    navigateToMessage(notification): string {
      return RouteHelper.path({
        route: Route.formSubmission,
        modelOrId: notification.document_id,
        query: {
          message: notification.message_id,
        }
      })
    },
    notificationLink(notification): string {
      return this.isMessage(notification)
        ? this.navigateToMessage(notification)
        : this.navigateToMention(notification);
    },
    formattedAuthor(notification): string {
      const bits: string[] = []
      if (notification.author?.name) bits.push(`From ${notification.author.name}`)
      if (this.isMessage) bits.push('at')
      return bits.join(' ')
    },
    isMessage(notification): boolean {
      return notification.app_notification_type === AppNotificationType.Message;
    },
    isUserMention(notification): boolean {
      return notification.app_notification_type === AppNotificationType.UserMentionNotification;
    },
    glyphFor(notification): string {
      return this.isMessage(notification) ? "email" : "gear";
    },
    shouldShowAuthor(notification): boolean {
      return this.isMessage || this.isUserMention;
    }
  },
});
</script>